import { createApp } from 'vue'
import Pagination from '@/components/Pagination/index.vue'

export function injectComponent(app: ReturnType<typeof createApp>){

  app.component('pagination', Pagination)
}